<div class="layer-wrapper">
  <div class="map-toolbar">
    <radio
      *ngIf="!isReadonly"
      [options]="radioOptions"
      [controlled]="true"
      name="selectionMode"
      [value]="selectionMode"
      (onChange)="selectionModeChange($event)"
    ></radio>
  </div>
  <map-coordinates-finder
    *ngIf="isCoordinatesPopupVisible"
    (onClose)="isCoordinatesPopupVisible = false"
    [map]="map"
  ></map-coordinates-finder>

  <div id="ol-map" class="ol-map"></div>

  <div #olPopup class="ol-popup" [ngClass]="{ 'is-open': isPopupVisible }">
    <a href="#" class="ol-popup-closer"></a>
    <div class="ol-popup-content">
      <div>
        <b>{{ 'LABEL' | translate }}</b
        >:
        <span>{{ popupData.label || '-' }}</span>
      </div>
      <div>
        <b>{{ 'VALUE' | translate }}</b
        >:
        <span>{{ popupData.value || '-' }}</span>
      </div>
    </div>
  </div>
</div>
